export default __webpack_public_path__ + "static/media/imgIpad.21f12c13.png";